import { render, staticRenderFns } from "./PatientLocationDropdown.vue?vue&type=template&id=800a61b4&scoped=true&"
import script from "./PatientLocationDropdown.vue?vue&type=script&lang=js&"
export * from "./PatientLocationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800a61b4",
  null
  
)

export default component.exports